<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">
              Nomor
              <i
                :class="
                  currentSort === 'nomor'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('nama_kegiatan_usaha_utama')">
              Nama Kegiatan Usaha Utama
              <i
                :class="
                  currentSort === 'nama_kegiatan_usaha_utama'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kode')">
              Kode
              <i
                :class="
                  currentSort === 'kode'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('deskripsi')">
              Deskripsi
              <i
                :class="
                  currentSort === 'deskripsi'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('skala')">
              Skala
              <i
                :class="
                  currentSort === 'skala'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('last_modified_date')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'last_modified_date'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('last_modified_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'last_modified_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('status')">
              Status
              <i
                :class="
                  currentSort === 'status'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('catatan')">
              Catatan
              <i
                :class="
                  currentSort === 'catatan'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ $get(list, 'parent.desc', '-') }}</td>
            <td>{{ list.kode }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ list.skala_besar }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <DKBLI
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    DKBLI: () => import('@/views/MasterData/Edit/LegalDoc/DKBLI.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: '',
        parent_id: '',
        kode: '',
        desc: '',
        skala_besar: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          nomor: 1,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1111,
          deskripsi: 'Pertanian Jagung',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 1',
        },
        {
          nomor: 2,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1112,
          deskripsi: 'Pertanian Gandum',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 2',
        },
        {
          nomor: 3,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1113,
          deskripsi: 'Pertanian Kedelai',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 3',
        },
        {
          nomor: 4,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1114,
          deskripsi: 'Pertanian Kacang Tanah',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 4',
        },
        {
          nomor: 5,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1115,
          deskripsi: 'Pertanian Kacang Hijau',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 5',
        },
        {
          nomor: 6,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1116,
          deskripsi: 'Pertanian Aneka Kacang Hortikultura',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 6',
        },
        {
          nomor: 7,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1117,
          deskripsi: 'Pertanian Biji-bijian Penghasil Minyak Makan',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 7',
        },
        {
          nomor: 8,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1118,
          deskripsi: 'Pertanian Biji-bijian Penghasil Bukan Minyak Makan',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 8',
        },
        {
          nomor: 9,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1119,
          deskripsi:
            'Pertanian Serealia Lainnya, Aneka Kacang Dan Biji-bijian Penghasil Minyak Lainnya',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 9',
        },
        {
          nomor: 10,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1121,
          deskripsi: 'Pertanian Padi Hibrida',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 10',
        },
        {
          nomor: 11,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1122,
          deskripsi: 'Pertanian Padi Inbrida',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 11',
        },
        {
          nomor: 12,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1131,
          deskripsi: 'Pertanian Hortikultura Sayuran Daun',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 12',
        },
        {
          nomor: 13,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1132,
          deskripsi: 'Pertanian Hortikultura Buah',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 13',
        },
        {
          nomor: 14,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1133,
          deskripsi: 'Pertanian Hortikultura Sayuran Buah',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 14',
        },
        {
          nomor: 15,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1134,
          deskripsi: 'Pertanian Hortikultura Sayuran Umbi',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 15',
        },
        {
          nomor: 16,
          nama_kegiatan_usaha_utama: 'Pertanian, Kehutanan, Perikanan',
          kode: 1135,
          deskripsi: 'Pertanian Aneka Umbi Palawija',
          skala: 'Menengah Tinggi',
          last_modified_date: '28/12/2021 07:21',
          last_modified_by: 'Sistem',
          status: 'Active',
          catatan: 'Test 16',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        parent_id: data.parent_id,
        kode: data.kode,
        desc: data.desc,
        skala_besar: data.skala_besar,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    subKbliData() {
      const result = this.$store.state.mdDatabaseStore.subKbliData
      return result
    },
    sortedData() {
      return this.subKbliData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
